module.exports = __webpack_public_path__ + "static/media/fic-website.c3bdb96b.png";